module.exports = __webpack_public_path__ + "fe38315a641bbd55b19543160154e802.pdf";